import React, { useState, useEffect } from 'react';
import { api } from '../../api/axios';
import { useAuth } from '../../hooks/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faUserTie,
    faChalkboardTeacher,
    faBookOpen
} from '@fortawesome/free-solid-svg-icons';
import styles from './SchoolAdminDashboard.module.css';

interface KPICardProps {
    title: string;
    value: string;
    icon: any;
    colorClass?: string;
}

const KPICard: React.FC<KPICardProps> = ({ title, value, icon, colorClass }) => {
    return (
        <div className={styles.card}>
            <div className={styles['kpi-content']}>
                <div>
                    <p className={styles['kpi-title']}>{title}</p>
                    <h3 className={`${styles['kpi-value']} ${colorClass ? styles[colorClass] : ''}`}>{value}</h3>
                </div>
                <div className={styles['kpi-icon-wrapper']}>
                    <FontAwesomeIcon icon={icon} className={colorClass ? styles[colorClass] : ''} style={{ fontSize: '24px' }} />
                </div>
            </div>
        </div>
    );
};

const SchoolAdminDashboard = () => {
    const { user } = useAuth()!;

    const [stats, setStats] = useState({
        totalStudents: "0",
        totalTeachers: "0",
        totalClasses: "0",
        activeSubjects: "0"
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await api.get('/dashboard/school-admin/stats');
                if (response.data?.data) {
                    setStats(response.data.data);
                }
            } catch (error) {
                console.error("Failed to fetch dashboard stats", error);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>School Overview</h1>

            <div className={styles['grid-4']}>
                <KPICard
                    title="Total Students"
                    value={stats.totalStudents}
                    icon={faUsers}
                    colorClass="text-blue"
                />
                <KPICard
                    title="Total Teachers"
                    value={stats.totalTeachers}
                    icon={faUserTie}
                    colorClass="text-purple"
                />
                <KPICard
                    title="Total Classes"
                    value={stats.totalClasses}
                    icon={faChalkboardTeacher}
                    colorClass="text-green"
                />
                <KPICard
                    title="Active Subjects"
                    value={stats.activeSubjects}
                    icon={faBookOpen}
                    colorClass="text-orange"
                />
            </div>
        </div>
    );
};

export default SchoolAdminDashboard;